import { MantineTheme, createStyles } from "@mantine/styles";

export const useStyles = createStyles((theme: MantineTheme) => ({
  mainContainer: {
    width: "100%",
    height: "100vh",
    background: "#FFFFFF",
    display: "flex",
    flexDirection: "row",
    margin: 0,
    position: "relative",
    overflow: "hidden",
  },
  container: {
    display: "flex",
    height: "100vh",
  },

  iconContainer: {
    position: "absolute",
    top: "58px",
    left: "85px",
    width: "151px",
    zIndex: 2,
  },
  leftContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  pageContainer: {
    display: "flex",
    alignItems: "center",
    padding: "30px 50px",
    maxWidth: "600px",
  },
  stepContent: {
    display: "flex",
    alignItems: "center",
    paddingBottom: "30px",
  },
  backImage: {
    display: "flex",
    width: "full",
  },
  logo: {
    width: 170,
    marginTop: 56,
    marginLeft: 0,
  },
  sidebar: {
    width: "250px",
    height: "100vh",
  },
}));
